import type { ComponentLoaderType } from '@grafikr/components';

const Loader: ComponentLoaderType = ({ node, emitter }, load) => {
  const events = node.dataset.loadEvent?.split(' ');

  if (!events) {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.error(node, 'Element needs a data-load-event attribute');
    }

    return () => {};
  }

  events.forEach((event) => {
    emitter.on(event, load);
  });

  return () => {
    events.forEach((event) => {
      emitter.off(event, load);
    });
  };
};

export default Loader;
